import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { IcepackFilledFormView } from './icepack-filled-form-view';
import {
	getIcepacksOptionsSelector,
	getIsIcepacksLoadingSelector,
	getIcepacksFillersOptionsSelector,
	getIsIcepacksFillersLoadingSelector,
	getIcepacksStatesOptionsSelector,
	getIsIcepacksStatesLoadingSelector,
	getModesOptionsSelector,
	getIsModesLoadingSelector,
	getFormInitialValuesSelector,
} from '../../selectors';
import { ICEPACK_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const IcepackFormWrapper = ({
	icepacksOptions,
	isIcepacksLoading,
	icepacksFillersOptions,
	isIcepacksFillersLoading,
	icepacksStatesOptions,
	isIcepacksStatesLoading,
	modesOptions,
	isModesLoading,
	isLoading,
}) => (
	<IcepackFilledFormView
		icepacksOptions={icepacksOptions}
		isIcepacksLoading={isIcepacksLoading}
		icepacksFillersOptions={icepacksFillersOptions}
		isIcepacksFillersLoading={isIcepacksFillersLoading}
		icepacksStatesOptions={icepacksStatesOptions}
		isIcepacksStatesLoading={isIcepacksStatesLoading}
		modesOptions={modesOptions}
		isModesLoading={isModesLoading}
		isLoading={isLoading}
	/>
);

const withForm = reduxForm({
	form: ICEPACK_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(IcepackFormWrapper);

const mapStateToProps = createStructuredSelector({
	icepacksOptions: getIcepacksOptionsSelector(),
	isIcepacksLoading: getIsIcepacksLoadingSelector(),
	icepacksFillersOptions: getIcepacksFillersOptionsSelector(),
	isIcepacksFillersLoading: getIsIcepacksFillersLoadingSelector(),
	icepacksStatesOptions: getIcepacksStatesOptionsSelector(),
	isIcepacksStatesLoading: getIsIcepacksStatesLoadingSelector(),
	modesOptions: getModesOptionsSelector(),
	isModesLoading: getIsModesLoadingSelector(),
	initialValues: getFormInitialValuesSelector(),
});

IcepackFormWrapper.propTypes = {
	icepacksOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksLoading: PropTypes.bool.isRequired,
	icepacksFillersOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksFillersLoading: PropTypes.bool.isRequired,
	icepacksStatesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksStatesLoading: PropTypes.bool.isRequired,
	modesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	initialValues: PropTypes.object,
};

const IcepackForm = connect(mapStateToProps)(withForm);

export { IcepackForm };
